import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import MultipleSelect from '../../components/common/multiselect.jsx';
import cityimg from '../../images/City.svg';
import defaultImage from '../../images/default.gif';
import postalimg from '../../images/post-office.png';
import InputMask from 'react-input-mask';
import moment from 'moment';
import s from '../../services/allservices.jsx';
import '../../stylesheet/imagehover.css';
import '../../stylesheet/personalinfo.css';
import Loader from '../loader/loader.jsx';
import FormHelperText from '@material-ui/core/FormHelperText';
import ConsumerPdfViewer from '../register/kycdocumentviewer'
import LoaderSmall from "../loader/loadersmall.jsx";
import ProfileUpdateModal from './profileupdate.jsx';
import ViewUserModal from './viewusermodal.jsx';
import Checkbox from '@material-ui/core/Checkbox'
import { Error, errorParser } from '../../components/common/validations'
import { TvRounded } from '@material-ui/icons';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#FFCE39"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid rgb(224, 224, 224)",
        bottom: "22px",
        position: "relative",
        width: "100%"

    }
};

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');


const getSuggestions = (value, countryState) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    const suggestions = countryState.filter(country => regex.test(country.name));

    if (suggestions.length === 0) {
        return [
            { name: "No Country Found" }
        ];
    }

    return suggestions;
}

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    profileState: state.getProfileReducer.profileState,
    cardState: state.getCardReducer.cardState,
    countryState: state.countryReducer.countryState
})
const mapDispatchToProps = dispatch =>
({
    fetchProfileState(history) {
        dispatch(
            actions.getProfileAction(history)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchCountryState() {
        dispatch(
            actions.countryAction()
        )
    }
})
const JSEncrypt = window.JSEncrypt
class PersonalInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: localStorage.getItem('address'),
            basic: true,
            contact: true,
            disabled: true,
            disablepi: true,
            disabled1: true,
            disabledmail: true,
            disabledmailempty: true,
            disabledcontact: true,
            mailing: true,
            emailState: true,
            cityState: true,
            correcthome: true,
            correctstate: true,
            correctphone: true,
            correctEmail: true,
            correctpasscode: true,
            pincodeState: true,
            phoneState: true,
            dateofbirth: '',
            correctcountry: true,
            correctMCity: true, correctMpasscode: true, correctMadd: true, correctMstate: true, correctMcountry: true,
            coreectfirstName: true, coreectdateofbirth: true,
            firstName: '',
            lastName: '',
            gender: '',
            emailId: '',
            city: '',
            pincode: '',
            mpincode: '',
            correctCity: true,
            correctStreet: true,
            selectedCard: [],
            cardDetailsId: "",
            suggestions: [],
            value: '',
            country: '',
            countryCode: '',
            country1: '',
            countryCode1: '',
            value2: '',
            value3: '',
            value4: '',
            value5: '',
            maddress: '',
            maddress2: '',
            photoURL: '',
            mediaInfo: '',
            stateState: true,
            state1: '',
            address1: '',
            streetNumber: "",
            correctadd: true,
            addState: true,
            homeState: true,
            dateSelected: false,
            // uploadFile: false,
            genderSelected: false,
            openModal: false,
            KycConsent: false,
            EnableCheckbox: false,
            selectedKycDetails: [],
            idType: "DRIVERS_LICENCE",
            documentFront: "",
            isvalidExpiry: true,
            address2: '',
            parsedErrors: {},
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSubmitPersonalInfo = this.handleSubmitPersonalInfo.bind(this)
        this.handleSubmitMailinginfo = this.handleSubmitMailinginfo.bind(this)

        this.handleBasic = this.handleBasic.bind(this)
        this.handleContact = this.handleContact.bind(this)
        this.handleMailing = this.handleMailing.bind(this)
        this.handleContactSubmit = this.handleContactSubmit.bind(this)
        this.handleMailingSubmit = this.handleMailingSubmit.bind(this)
        this.multipleSelect = this.multipleSelect.bind(this)
        this.handleMobile = this.handleMobile.bind(this)

    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            loader: true
        })
        try {

            if (nextProps.profileState && nextProps.profileState.length !== 0) {
                this.setState({
                    loader: false,
                    address1: this.props.profileState && this.props.profileState.body && this.props.profileState.body.address,
                    address2: this.props.profileState && this.props.profileState.body && this.props.profileState.body.address2,
                    country: this.props.profileState && this.props.profileState.body && this.props.profileState.body.country,
                    countryCode: this.props.profileState && this.props.profileState.body && this.props.profileState.body.countryCode,
                    city: this.props.profileState && this.props.profileState.body && this.props.profileState.body.city,
                    state1: this.props.profileState && this.props.profileState.body && this.props.profileState.body.state,
                    pincode: this.props.profileState && this.props.profileState.body && this.props.profileState.body.pincode,
                    emailId: this.props.profileState && this.props.profileState.body && this.props.profileState.body.emailId,
                    mobileNumber: this.props.profileState && this.props.profileState.body && this.props.profileState.body.mobileNumber,
                }, () => {


                })
            }
            else {

                this.setState({
                    loader: false
                })
            }
        } catch (e) { }
    }

    componentDidMount() {

        const { publicKey } = this.props


        // this.setState({
        //     address1 : this.props.profileState &&  this.props.profileState.body &&  this.props.profileState.body[0].address,
        //     address2 : this.props.profileState &&  this.props.profileState.body &&  this.props.profileState.body[0].address2,
        //     country : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].country,
        //     city : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].city,
        //     state1 : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].state,
        //     pincode : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].pincode,
        //     emailId : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].emailId ,
        //     mobileNumber : this.props.profileState &&  this.props.profileState.body && this.props.profileState.body[0].mobileNumber ,
        // })

        this.props.fetchCountryState()
        this.props.fetchProfileState(this.props.history);

        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)

            }
        }, 500);

    }
    componentWillMount() {
        this.props.fetchCountryState();
    }

    // onChange1 = (event, { newValue, method }) => {
    //     let addval = newValue.trim()
    //     if (newValue.name == "") {
    //         this.setState({
    //             disabledcontact: false
    //         })
    //     }
    //     else {
    //         this.setState({
    //             value3: newValue,
    //             disabledcontact: true
    //         })

    //     }
    // };

    // onChange2 = (event, { newValue, method }) => {
    //     let addval = newValue.trim()
    //     if (newValue.name == " ") {
    //         this.setState({
    //             disabledmail: false
    //         })
    //     }
    //     else {
    //         this.setState({
    //             value2: newValue,
    //             disabledmail: true
    //         })

    //     }

    // };
    removeemail = () => {
        this.setState({
            emailState: true
        })
    }
    removecity = () => {
        this.setState({
            cityState: true
        })
    }
    removepasscode = () => {
        this.setState({
            pincodeState: true
        })
    }

    removephone = () => {
        this.setState({
            phoneState: true
        })
    }

    removestate = () => {
        this.setState({
            stateState: true
        })
    }
    streetNumber = () => {
        this.setState({
            streetNumber: true
        })
    }
    removeadd = () => {
        this.setState({
            addState: true
        })
    }
    removehome = () => {
        this.setState({
            homeState: true
        })
    }
    multipleSelect(e) {

        e.preventDefault()
        let body = this.props.countryState

        let item = body.find(item => item.name === e.target.value)
        this.props.multiSelect({ name: [e.target.name], value: item })

    }
    handleMobile() {
        const { mobileNumber } = this.state
        // let arr = []
        let no = mobileNumber.split('')
        no.unshift('0')

        let num = no.join('')

        this.setState({
            mobileNumber: num
        })
    }


    getSuggestionValue = suggestion => {

        // if(suggestion.name="No Country Found"){
        //     this.setState({
        //         correctcountry:false
        //     })
        // }
        this.setState({
            country: suggestion.name,
            countryCode: suggestion.alpha3Code
        }, () => {

        })
        return suggestion.name;
    };


    renderSuggestion = suggestion => {
        return suggestion.name || suggestion.name;
    };

    onSuggestionsFetchRequested = ({ value }) => {

        this.setState({
            suggestions: getSuggestions(value, this.props.countryState)
        }, () => {

        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: this.state.country
        });
    };


    // onSuggestionSelected1 = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    //     if (suggestionValue !== "" && suggestionValue !== "No Country Found") {

    //         this.setState({
    //             disabledmail: false
    //         })
    //     }
    //     else {
    //         this.setState({
    //             disabledmail: true
    //         })
    //     }
    // };

    // onSuggestionSelected2 = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    //     if (suggestionValue !== "" && suggestionValue !== "No Country Found") {

    //         this.setState({
    //             disabledmailempty: false,

    //         })
    //     }
    //     else {
    //         this.setState({
    //             disabledmailempty: true
    //         })
    //     }
    // };
    // onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    //     if (suggestionValue !== "" && suggestionValue !== "No Country Found") {


    //         this.setState({
    //             disabledcontact: false,

    //         }, () => {
    //             if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.value3.length !== 0) {
    //                 this.setState({
    //                     disabledcontact: false
    //                 })
    //             } else {
    //                 this.setState({
    //                     disabledcontact: true
    //                 })
    //             }
    //         })
    //     }
    //     else {
    //         this.setState({
    //             disabledcontact: true
    //         })
    //     }
    // };
    converSelectedDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [(dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear(),].join('/');
    }




    converDate = (date) => {

        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }


    formatDate = (date) => {

        if (date !== undefined) {
            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()

            return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
        }
    }
    handleDate = (e, date) => {

        // if(date !== null){
        this.setState({
            dateofbirth: this.converDate(date),
            dateSelected: true
        }, () => {

            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
        // }
        // else{
        //     this.setState({
        //         dateofbirth:null,
        //         disabled: true
        //     }) 
        // }
    }

    // handleGender = (event, index, value1) => {

    //     if (value1 !== null) {
    //         this.setState({
    //             gender: value1,
    //             genderSelected: true
    //         }, () => {

    //             if (this.state.firstName.length !== 0 && this.state.gender.length !== 0 && this.state.dateofbirth !== null) {
    //                 this.setState({
    //                     disabled: false
    //                 })
    //             } else {
    //                 this.setState({
    //                     disabled: true
    //                 })
    //             }
    //         });
    //     }
    //     else {
    //         this.setState({
    //             gender: "",
    //             disabled: true
    //         })
    //     }
    // }
    handleLastName = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                lastName: value
            }, () => {

                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
        else {
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    lastName: "",
                    disabled: false
                })
            }

        }
    }
    handleMiddleName = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                middleName: value
            }, () => {

                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
        else {
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    lastName: "",
                    disabled: false
                })
            }

        }
    }

    handleFirstName = (e, value) => {

        let addval = value.trim()
        if (e.target.name === "firstName" && value.length !== 0) {

            this.setState({

                firstName: addval,

            }, () => {


                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })

        } else {
            this.setState({
                firstName: "",
                disabled: true
            })
        }
    }
    handleMailingSubmit() {
        const { correctMCity, correctMpasscode, correctMadd, correctMstate } = this.state
        const { profileState } = this.props

        if (correctMCity === false) {
            this.setState({
                correctMCity: false,
            })
        }
        else if (correctMpasscode === false) {
            this.setState({
                correctMpasscode: false,
            })
        }
        else if (correctMadd === false) {
            this.setState({
                correctMadd: false,
            })
        }
        else if (correctMstate === false) {
            this.setState({
                correctMstate: false,
            })
        }


        else {
            this.setState({
                loader: true
            })
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.maddress,
                address2: this.state.maddress2,
                city: this.state.mcity,
                country: this.state.country1 || profileState.body.mailingInformation.country,
                countryCode: this.state.countryCode1,
                mailingId: localStorage.getItem("mailingId"),
                memberId: localStorage.getItem("memberId"),
                pincode: this.state.mpincode,
                state: this.state.mstate1
            }
            let _this = this
            let token = "Token " + localStorage.getItem('token')
            if (state.address !== "" || state.address2 !== "" || state.city !== "" || state.country !== "" || state.pincode !== "" || state.state !== "") {
                this.setState({
                    loader: true
                })

                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let traceId = getClientId();
                fetch(plink + s.update_mailing, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                        'X-Trace-Id': traceId,
                        'X-KlickEx-Client':buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            response.json().then(function () {
                                _this.props.fetchProfileState(this.props.history);
                                _this.setState({
                                    mailing: !_this.state.mailing
                                })
                            })
                            this.setState({
                                loader: false
                            })
                        } else {
                            this.setState({
                                loader: false
                            })
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })
            }
        }
    }

    handleContactSubmit() {
        const { correctCity, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props
        if (correctCity === false) {
            this.setState({
                correctCity: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        }
        else if (correctpasscode === false) {
            this.setState({
                correctpasscode: false,
            })
        } else if (correctadd === false) {
            this.setState({
                correctadd: false,
            })
        }
        else if (correctPhone === false) {
            this.setState({
                correctPhone: false,
            })
        } else if (correcthome === false) {
            this.setState({
                correcthome: false,
            })
        } else if (correctstate === false) {
            this.setState({
                correctstate: false,
            })
        }


        else {
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                country: this.state.country || profileState.body.country,
                countryCode: this.state.countryCode,
                homePhoneNumber: this.state.homePhoneNumber,
                memberId: localStorage.getItem("memberId"),
                mobileNumber: this.state.mobileNumber,
                pincode: this.state.pincode,
                state: this.state.state1,
                emailId: this.state.emailId
            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })

            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.update_contact, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client':buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        response.json().then(function () {

                            _this.props.fetchProfileState(this.props.history);
                            _this.setState({
                                contact: !_this.state.contact
                            })
                        })
                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: true
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });



                    }
                })
        }
    }
    handleSubmitMailinginfo = () => {

        const { correctCity, correctMCity, correctMpasscode, correctMadd, correctMstate, coreectfirstName, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props

        if (correctMCity === false) {
            this.setState({
                correctMCity: false,
            })
        }
        else if (correctMpasscode === false) {
            this.setState({
                correctMpasscode: false,
            })
        }
        else if (correctMadd === false) {
            this.setState({
                correctMadd: false,
            })
        }
        else if (correctMstate === false) {
            this.setState({
                correctMstate: false,
            })
        }
        else {
            const state = {

                cardDetailsId: this.state.cardDetailsId,
                address: this.state.maddress,
                address2: this.state.maddress2,
                city: this.state.mcity,
                country: this.state.country1,
                countryCode: this.state.countryCode1,
                mailingId: localStorage.getItem("mailingId"),
                memberId: localStorage.getItem("memberId"),
                pincode: this.state.mpincode,
                state: this.state.mstate1,


            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.update_mailinginfo , {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client':buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        setTimeout(function () { window.location.reload(true); }, 500);
                        response.json().then(function () {

                            _this.props.fetchProfileState(this.props.history);
                            // _this.setState({
                            //     basic: !_this.state.basic
                            // })
                            // _this.setState({
                            //     contact: !_this.state.contact
                            // })
                            // _this.setState({
                            //     mailing: !_this.state.mailing
                            // })
                        })

                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });


                    }
                })
        }
    }

    handleSubmitPersonalInfo = () => {
        const state = {
            emailAddress: this.state.emailId,
            contactNo: this.state.mobileNumber
        }
        console.log("email and mobile number ", state)

        let _this = this
        let token = "Token " + localStorage.getItem('token')
        this.setState({
            loader: true
        })

        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.update_profile_personalInfo, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': "Token " + localStorage.getItem('token'),
                'X-Trace-Id': traceId,
                'X-KlickEx-Client':buildClientHeader(),
                
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    setTimeout(function () { window.location.reload(true); }, 500);
                    response.json().then(function () {
                        _this.props.fetchProfileState(this.props.history);
                    })

                    this.setState({
                        loader: false
                    })
                } else {
                    this.setState({
                        loader: false
                    })
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });

                }
            })

    }

    handleSubmit = () => {

        const { correctCity, correctMCity, correctMpasscode, correctMadd, correctMstate, coreectfirstName, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props
        if (correctCity === false) {
            this.setState({
                correctCity: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        }
        else if (correctpasscode === false) {
            this.setState({
                correctpasscode: false,
            })
        } else if (correctadd === false) {
            this.setState({
                correctadd: false,
            })
        }
        else if (correctPhone === false) {
            this.setState({
                correctPhone: false,
            })
        } else if (correcthome === false) {
            this.setState({
                correcthome: false,
            })
        } else if (correctstate === false) {
            this.setState({
                correctstate: false,
            })
        }

        else if (coreectfirstName === false) {
            this.setState({
                coreectfirstName: false,
            })
        }
        else {
            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardDetailsId: this.state.cardDetailsId,
                dateofbirth: this.state.dateSelected === true ? this.state.dateofbirth : this.state.dobDate,
                firstName: this.state.firstName,
                gender: this.state.gender,
                lastName: this.state.lastName,
                memberId: localStorage.getItem("memberId"),
                middleName: null,
                address: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                country: this.state.country || profileState.body.country,
                countryCode: this.state.countryCode,
                homePhoneNumber: this.state.homePhoneNumber,
                mobileNumber: this.state.mobileNumber,
                pincode: this.state.pincode,
                state: this.state.state1,
                emailId: this.state.emailId,
                "mailingInformation": null,

                // idExpiry: this.state.idExpiry1 === undefined ? this.props.profileState.body.idExpiry : this.state.idExpiry1,
                // countryOfIssue: this.state.countryOfIssue,
                // idNumber: this.state.idNumber,
                // idType: "DRIVERS_LICENCE",
                // documentFront: this.state.documentFront,
                // scanMIME: this.state.fileType,
                // idStateOfIssue: this.state.idStateOfIssue,
                // extraData: this.state.extraData,
                // streetNumber: this.state.streetNumber,

                // "mailingInformation": {
                //     cardDetailsId: this.state.cardDetailsId,
                //     address: this.state.maddress,
                //     address2: this.state.maddress2,
                //     city: this.state.mcity,
                //     country: this.state.country1,
                //     countryCode: this.state.countryCode1,
                //     mailingId: localStorage.getItem("mailingId"),
                //     memberId: localStorage.getItem("memberId"),
                //     pincode: this.state.mpincode,
                //     state: this.state.mstate1,
                // }

            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let gid = getClientId();
            let traceId = getClientId();
            fetch(plink + s.update_profile , {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'clientId': gid,
                    'clientSecret': getClientSecret(gid, this.state.firstName),
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client':buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        setTimeout(function () { window.location.reload(true); }, 500);
                        response.json().then(function () {
                            _this.props.fetchProfileState(this.props.history);
                        })

                        this.setState({
                            loader: false
                        })
                    } else if (response.status === 400) {
                        response.json()
                            .then(json => {
                                this.parseErrors(json.errors)
                            })
                        this.setState({
                            loader: false
                        })
                    }
                    else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });


                    }
                })
        }
    }

    handleBasic = () => {


        this.setState({
            basic: !this.state.basic
        })
    }
    handleContact(State) {
        if (this.state.address1 === State.address1 && this.state.city === State.city && this.state.state1 === State.state1 && this.state.mobileNumber === State.mobileNumber && this.state.address2 === State.address2 && this.state.homeState === State.homeState && this.state.country === State.country && this.state.emailId === State.emailId && this.state.pincode === State.pincode) {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        this.setState({
            contact: !this.state.contact
        })
    }
    handleMailing(State) {
        if (this.state.maddress === State.address && this.state.mcity === State.city && this.state.mstate1 === State.state && this.state.maddress2 === State.address2 && this.state.country === State.country && this.state.mpincode === State.pincode) {

            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        this.setState({
            mailing: !this.state.mailing
        })

    }
    toDate(date) {

        let date1 = new Date(date)
        return date1.getDate() + "/" + parseInt(date1.getMonth() + 1, 10) + "/" + date1.getFullYear()
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    componentWillReceiveProps(nextProps, date) {

        if (this.checkObject(nextProps.profileState.body)) {

            if (nextProps.profileState.body.mailingInformation === null) {


                this.setState({
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    countryOfIssue: nextProps.profileState.body.countryOfIssue,
                    fileType: nextProps.profileState.body.scanMIME,
                    extraData: nextProps.profileState.body.extraData,
                    idExpiry: this.converSelectedDate(new Date(nextProps.profileState.body.idExpiry)),
                    idType: nextProps.profileState.body.idType,
                    countryCode: nextProps.profileState.body.countryCode,
                    documentIssuedCountryName: nextProps.profileState.body.documentIssuedCountryName,
                    idNumber: nextProps.profileState.body.idNumber,
                    idStateOfIssue: nextProps.profileState.body.idStateOfIssue,
                    documentFront: nextProps.profileState.body.documentFront,
                    extraData: nextProps.profileState.body.extraData,
                    uploadFile: nextProps.profileState.body.documentFront === null ? true : false,
                    streetNumber: nextProps.profileState.body.streetNumber


                }, () => {

                })
            } else if (nextProps.profileState.body.mailingInformation !== null) {
                this.setState({
                    country1: nextProps.profileState.body.mailingInformation.country,
                    countryCode1: nextProps.profileState.body.mailingInformation.countryCode,
                    maddress: nextProps.profileState.body.mailingInformation.address,
                    maddress2: nextProps.profileState.body.mailingInformation.address2,
                    mcity: nextProps.profileState.body.mailingInformation.city,
                    mstate1: nextProps.profileState.body.mailingInformation.state,
                    mpincode: nextProps.profileState.body.mailingInformation.pincode,
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    streetNumber: nextProps.profileState.body.streetNumber,
                    countryName1: nextProps.profileState.body.countryOfIssue,


                    countryOfIssue: nextProps.profileState.body.countryOfIssue,
                    fileType: nextProps.profileState.body.scanMIME,
                    extraData: nextProps.profileState.body.extraData,
                    idExpiry: this.converSelectedDate(new Date(nextProps.profileState.body.idExpiry)),
                    idType: nextProps.profileState.body.idType,
                    countryCode: nextProps.profileState.body.countryCode,
                    documentIssuedCountryName: nextProps.profileState.body.documentIssuedCountryName,
                    idNumber: nextProps.profileState.body.idNumber,
                    idStateOfIssue: nextProps.profileState.body.idStateOfIssue,
                    documentFront: nextProps.profileState.body.documentFront,


                    uploadFile: nextProps.profileState.body.documentFront === null ? true : false,

                })
            } else if (nextProps.profileState.body.profilePicture !== null) {
                this.setState({
                    mediaInfo: nextProps.profileState.body.profilePicture.mediaInfo,
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    //dateofbirth:this.handleDate(dateOfBirth),
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    streetNumber: nextProps.profileState.body.streetNumber
                })
            }
        }

        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                var filteredG = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "G")

                })

                var filteredR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "R")
                })
                var filteredCards = filteredG.concat(filteredR)

                this.setState({
                    loader: false,
                    cardDetailsId: filteredCards[0].cardDetailsId,
                    selectedCard: filteredCards[0],
                    filteredCards: filteredCards
                })
            }
        } catch (e) {

        }


    }
    handleStreetNumber = (e, value) => {
        console.log("StreetNumber Value :", value);
        let addval = value.trim()
        if (value.length !== 0) {
            this.setState({
                streetNumber: e.target.value,
                correctStreet: true
            }, () => {
                if (this.state.streetNumber !== this.props.profileState.body.streetNumber) {
                    this.setState({
                        EnableCheckbox: true,
                    }, () => {
                        if (this.state.streetNumber !== null && this.state.streetNumber.length !== 0 && this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null
                            && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false,

                            })
                        } else {
                            this.setState({
                                disabled: true,

                            })
                        }
                    })
                }
                else {
                    this.setState({
                        EnableCheckbox: false,

                    })
                }



            })
        }
        else {
            this.setState({
                streetNumber: "",
                correctStreet: false,
                disabled: true
            })
        }
    }


    handleaddress1 = (e, value) => {

        let addval = value.trim()

        if (value.length !== 0) {
            this.setState({
                address1: addval
            }, () => {
                if (this.state.address1 !== this.props.profileState.body.address1) {
                    this.setState({
                        EnableCheckbox: true

                    }, () => {
                        if (this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null
                            && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false,

                            })
                        } else {
                            this.setState({
                                disabled: true,

                            })
                        }
                    })
                }

                else {
                    this.setState({
                        EnableCheckbox: false
                    })

                }
                // 

            })
        }
        else {
            this.setState({
                address1: "",
                disabled: true
            })
        }
    }

    handleaddress2 = (e, value) => {
        let addval = value.trim()
        this.setState({
            address2: addval,
        })
        // if (value.length !== 0) {
        //     this.setState({
        //         address2: addval,
        //     }, () => {
        //         if (this.state.address2 !== this.props.profileState.body.address2) {
        //             this.setState({
        //                 EnableCheckbox: true
        //             }, () => {
        //                 if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true &&  this.state.isvalidExpiry === true) {
        //                     this.setState({
        //                         disabled: false
        //                     })
        //                 } else {
        //                     this.setState({
        //                         disabled: true
        //                     })
        //                 }
        //             })
        //         }
        //         else {
        //             this.setState({
        //                 EnableCheckbox: false
        //             })

        //         }



        //     })
        // }
    }
    handleStatedropdown = (event, index, value) => {

        this.setState({
            state1: value
        }, () => {
            if (this.state.state1 !== this.props.profileState.body.state) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    EnableCheckbox: false
                })

            }


        })
    }

    handleMailingStatedropdown = (event, index, value) => {

        this.setState({
            mstate1: value
        }, () => {

            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {

                this.setState({
                    disabled1: true
                })
            }
        })

    }
    handleIDStatedropdown = (event, index, value) => {

        this.setState({
            idStateOfIssue: value
        }, () => {
            if (this.state.idStateOfIssue !== this.props.profileState.body.idStateOfIssue) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0
                        && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    EnableCheckbox: false
                })

            }
        })
    }
    handlestate1 = (e, value) => {
        let addval = value.trim()
        if (value.length !== 0) {
            this.setState({
                state1: addval
            }, () => {
                if (this.state.state1 !== this.props.profileState.body.state) {
                    this.setState({
                        EnableCheckbox: true

                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }
                else {
                    this.setState({
                        EnableCheckbox: false
                    })

                }
            })
        }
        else {
            this.setState({
                state1: "",
                disabled: true
            })
        }
    }

    handelemail = (e, value) => {
        let addval = value.trim()
        this.setState({
            correctEmail: true,
            emailId: addval,
        })

        // if (e.target.name === "emailId" ) {
        // eslint-disable-next-line
        // if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(addval)) {
        //     this.setState({
        //         correctEmail: true,
        //         emailId: addval,

        //     }, () => {
        //         if (this.state.emailId !== this.props.profileState.body.emailId) {
        //             this.setState({
        //                // EnableCheckbox: true
        //             }, () => {
        //                 if ( this.state.emailId.length !== 0  && this.state.mobileNumber.length !== 0) {
        //                     this.setState({
        //                         disablepi: false
        //                     })
        //                 } else {
        //                     this.setState({
        //                         disablepi: true
        //                     })
        //                 }
        //             })
        //         }
        //         else {
        //             this.setState({
        //                 EnableCheckbox: false
        //             })

        //         }
        //     })

        // }else{
        //      this.setState({
        //         correctEmail: true,
        //         emailId: addval,

        //     })
        // }
        //}
        // else {
        //     this.setState({
        //         emailId: "",
        //         disabled: true,
        //     })
        // }
    }
    onFieldChange = (e, value) => {

        const { name } = e.target
        this.setState({
            [name]: e.target.value,
            disabled: false
        })
        if ((this.state.idStateOfIssue !== this.props.profileState.body.idStateOfIssue) || (this.state.idNumber !== this.props.profileState.body.idNumber) || (this.state.extraData !== this.props.profileState.body.extraData)) {
            this.setState({
                EnableCheckbox: true
            }, () => {
                if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }
        else {
            this.setState({
                EnableCheckbox: false
            })
        }
    }

    handelmobileNumber = (e, value) => {
        let addval = value.trim()
        var regx = /^\d{3,20}$/
        if (e.target.name === 'mobileNumber' && value.length >= 3) {
            if (regx.test(addval)) {
                this.setState({
                    correctphone: true,
                    mobileNumber: addval,
                }, () => {
                    if (this.state.mobileNumber !== this.props.profileState.body.mobileNumber) {
                        this.setState({
                            //EnableCheckbox: true
                        }, () => {
                            if (this.state.mobileNumber !== "" && this.state.emailId.length !== 0) {
                                this.setState({
                                    disablepi: false
                                })
                            } else {
                                this.setState({
                                    disablepi: true,
                                })
                            }
                        })
                    }
                })
            } else {
                this.setState({
                    correctphone: false,
                    mobileNumber: "",
                })
            }
        }
        else {
            this.setState({
                mobileNumber: "",
                correctphone: false,
                disabled: true
            })
        }
    }
    handelhomePhoneNumber = (e, value) => {
        var regx = /^\d{10}$/
        if (e.target.name === 'homePhoneNumber' && value.length !== 0) {
            if (regx.test(e.target.value)) {
                this.setState({
                    correcthome: true,
                    homePhoneNumber: e.target.value,

                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            } else {
                this.setState({
                    correcthome: false,

                })
            }
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }


    handlecity = (e, value) => {
        // let addval = value.trim()
        if (e.target.value.length !== 0) {
            this.setState({
                city: e.target.value
            }, () => {
                if (this.state.city !== this.props.profileState.body.city) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                } else {
                    this.setState({
                        correcthome: false,
                    })
                }
            })
        }
        else {
            this.setState({
                city: "",
                disabled: true
            })
        }
    }

    // handlecountry = (e, value) => {

    //     if (value.length !== 0) {
    //         this.setState({
    //             value3: value
    //         }, () => {
    //             if (this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.address2.length !== 0 && this.state.state1.length !== 0 && this.state.homePhoneNumber.length !== 0 && this.state.value3.length !== 0) {
    //                 this.setState({
    //                     disabledcontact: false
    //                 })
    //             } else {
    //                 this.setState({
    //                     disabledcontact: true
    //                 })
    //             }
    //         })
    //     }
    //     else {
    //         this.setState({
    //             disabledcontact: true
    //         })
    //     }
    // }

    handlepincode = (e, value) => {
        // let addval = value.trim()
        // var regx = /(^\d{6}$)|(^\d{6}-\d{5}$)/;
        var regx = /^\d{4,4}$/
        if (e.target.name === "pincode" && value.length !== 0) {


            if (regx.test(e.target.value)) {
                this.setState({
                    correctpasscode: true,
                    pincode: e.target.value,
                }, () => {
                    if (this.state.pincode !== this.props.profileState.body.pincode) {
                        this.setState({
                            EnableCheckbox: true
                        }, () => {
                            if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                                this.setState({
                                    disabled: false
                                })
                            } else {
                                this.setState({
                                    disabled: true
                                })
                            }
                        })
                    }
                })
            } else {
                this.setState({
                    correctpasscode: false,
                })
            }
        }
        else {
            this.setState({
                pincode: "",
                disabled: true
            })
        }
    }

    handlemaddress1 = (e, value) => {

        // var regexSpace = /^\s*-/;
        // let addval = value.trim()








        // if (regexSpace.test(value)) {

        this.setState({
            maddress: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })



    }

    handlemaddress2 = (e, value) => {
        // let addval = value.trim()


        this.setState({
            maddress2: e.target.value,


        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

        // else {
        //     if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

        //         this.setState({
        //             disabled: false
        //         })
        //     } else {
        //         this.setState({
        //             maddress2: "",
        //             disabled: true
        //         })
        //     }
        // }


    }
    // handlePress=()=>{
    //     var regexSpace= /^[^-\s][a-zA-Z0-9_\s-]+$/
    // }

    handlemstate1 = (e, value) => {
        // let addval = value.trim()


        this.setState({
            mstate1: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })


    }
    handleSpace = () => {


        // $(function() {
        //     $('body').on('keydown', '#maddress', function(e) {

        //       if (e.which === 32 ) {
        //         return false;
        //       }  
        //     });
        //   });

        // if (e.keyCode === 32) {

        //     return false;
        // }
    }

    handlemcity = (e, value) => {
        // let addval = value.trim()

        this.setState({
            mcity: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {
                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }



    handlemcountry = (e) => {
        const { name, term } = e.target
        // this.setState({ [name]: e.target.value })



        this.setState({
            country1: term,
            countryCode1: e.target.value
            // disabledmail: false

        }, () => {
            console.log(this.country)

            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {
                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

        //  else {
        //     this.setState({
        //         mcity: "",
        //         disabledmail: true
        //     })
        // }
        // else {
        //     this.setState({
        //         address1: "",
        //         disabledcontact: true
        //     })
        // }

    }
    handlempincode = (e, value) => {
        // let addval = value.trim()
        // var regx = /(^\d{6}$)|(^\d{6}-\d{5}$)/;



        if (e.target.name === "mpincode") {
            let regx1 = /^\d{4,4}$/




            if (regx1.test(e.target.value)) {

                this.setState({
                    correctMpasscode: true,
                    mpincode: e.target.value,

                }, () => {

                    if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.country1.length !== 0) {
                        this.setState({
                            disabled1: false
                        })
                    } else {
                        this.setState({
                            disabled1: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    correctMpasscode: false,
                    mpincode: e.target.value,
                    disabled: true

                })
            }

        }
    }


    // handlempincode = (e) => {
    //     // let addval = value.trim()

    //     var regx = /^[0-9]{4,4}$/
    //     if (e.target.name === "mpincode" && e.target.value.length !== 0) {
    //         
    //         if (regx.test(e.target.value)) {
    //             
    //             this.setState({
    //                 correctMpasscode: true,
    //                 mpincode: e.target.value,

    //             }, () => {
    //                 
    //                 // if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {
    //                 //     this.setState({
    //                 //         disabled: false
    //                 //     })
    //                 // } else {
    //                 //     this.setState({
    //                 //         disabled: true
    //                 //     })
    //                 // }
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 correctMpasscode: false,

    //             })
    //         }

    //     } else {
    //         this.setState({
    //             mpincode: "",
    //             // disabled: true
    //         })
    //     }

    // }



    handlemaddress1empty = (e, value) => {

        if (e.target.value.length !== 0) {
            this.setState({
                maddress: e.target.value,
                disabledmailempty: false
            }, () => {
                if (this.state.streetNumber !== "" && this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null) {
                    this.setState({
                        disabled: false
                    }, () => {

                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }
    handlemcountryIdDocument = (e) => {

        const { name, term } = e.target





        // this.setState({ [name]: e.target.value })


        if (e.target.value.length !== 0) {
            this.setState({
                // countryName1: e.target.value,
                countryOfIssue: e.target.value,
                disabled: false,

                // countryCode1: term,

            }, () => {
                if (this.state.countryOfIssue !== this.props.profileState.body.countryOfIssue) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }
            })
        }
        // 
    }


    handlemaddress2empty = (e, value) => {

        if (value.length !== 0) {

            this.setState({
                maddress2: value
            })
        }
    }

    handlemstate1empty = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                mstate1: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }


    handlemcityempty = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                mcity: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }

    handlemcountryempty = (e) => {
        const { name, term } = e.target
        this.setState({ [name]: e.target.value })



        if (e.target.value.length !== 0) {
            this.setState({
                country: term,
                countryCode: e.target.value,
                // disabled: false
            }, () => {
                if (this.state.countryCode !== this.props.profileState.body.countryCode) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }

            });
        }
        // else {
        //     this.setState({
        //         disabledcontact: true
        //     })
        // }
    }


    handlempincodeempty = (e, value) => {

        var regx = /^[0-9]{4,4}$/;
        if (e.target.name === "mpincode" && value.length !== 0) {
            if (regx.test(value)) {
                this.setState({
                    correctpasscode: true,
                    mpincode: value,
                    disabledmailempty: false

                })
            } else {
                this.setState({
                    correctpasscode: false,
                    disabledmailempty: true

                })
            }
        }
    }
    // onChangecontact = (e, value) => {

    //     if(e.target.name="maddress"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 maddress: value
    //             }, () => {

    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 maddress: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "mcity"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 mcity: value
    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         } else {
    //             this.setState({
    //                 mcity: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "mpincode"){
    //         var regx = /^[0-9]{4,4}$/
    //         if (e.target.name === "mpincode" && value.length !== 0) {
    //             if (regx.test(value)) {
    //                 this.setState({
    //                     correctMpasscode: true,
    //                     mpincode: value,

    //                 }, () => {
    //                     if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                         this.setState({
    //                             disabledmail: false
    //                         })
    //                     } else {
    //                         this.setState({
    //                             disabledmail: true
    //                         })
    //                     }
    //                 })
    //             } else {
    //                 this.setState({
    //                     correctMpasscode: false,

    //                 })
    //             }
    //         } else {
    //             this.setState({
    //                 mpincode: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }
    //     else if(e.target.name === "maddress2"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 maddress2: value,


    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         }
    //         else {
    //             this.setState({
    //                 maddress2: "",
    //                 disabledmail: false
    //             })
    //         }

    //     }
    //     else if(e.target.name==="mstate1"){
    //         if (value.length !== 0) {
    //             this.setState({
    //                 mstate1: value
    //             }, () => {
    //                 if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.value2.length !== 0) {
    //                     this.setState({
    //                         disabledmail: false
    //                     })
    //                 } else {
    //                     this.setState({
    //                         disabledmail: true
    //                     })
    //                 }
    //             })
    //         } else {
    //             this.setState({
    //                 mstate1: "",
    //                 disabledmail: true
    //             })
    //         }

    //     }





    //         // this.setState({
    //         //     [e.target.name]: e.target.value
    //         // })
    //         // if (this.state.maddress !== 0 && this.state.mcity.length !== 0 && this.state.mpincode !== null && this.state.mstate1 !== null && this.state.country.length !== 0 && this.state.country !== "No Country Found") {

    //         //     this.setState({
    //         //         disabledmail: false
    //         //     })
    //         // } else {
    //         //     this.setState({
    //         //         disabledmail: true
    //         //     })
    //         // }


    // }

    handleSelect1 = (event, index, value) => {
        const { filteredCards } = this.state
        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < filteredCards.length; i++) {
                if (this.state.cardDetailsId === filteredCards[i].cardDetailsId) {

                    this.setState({

                        selectedCard: filteredCards[i]
                    })
                }
            }
        });

    }
    handleClick = event => {
        const { target = {} } = event || {};
        target.value = "";
    };
    onFileChange = async (e) => {


        let _this = this
        const file1 = e.target.files[0]



        let filetype = file1.type

        // let extensionType = filetype.slice(6)

        // let _this = this

        var reader = new FileReader();
        reader.onloadend = function () {
            let result1 = reader.result

            let res = result1.slice(result1.indexOf(",") + 1)


            _this.setState({
                documentFront: res,
                fileType: filetype,
                fileName: file1.name,
                fileSize: file1.size,

                EnableCheckbox: true

            }, () => {
                this.state.KycConsent === true ?
                    this.setState({
                        disabled: false
                    })
                    :
                    this.setState({
                        disabled: true
                    })



                if (file1.size > 1000000) {
                    // this.handleClick()
                    toast.error('Uploaded File Size Should be Less Than 1 MB', {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })
        }
        reader.readAsDataURL(file1);


    }





    handleExpiry = (e) => {

        let exp_Date = e.target.value
        console.log(exp_Date)
        let expDate = ""
        let expDate1 = ""

        if (moment(exp_Date, "DD/MM/YYYY", true).isValid()) {
            const split = exp_Date.split('/');
            let day = split[0];
            let month = split[1];
            let year = split[2];

            expDate = `${year}-${month}-${day}`;
            expDate1 = `${day}${month}-${year}`;

            this.setState({
                isvalidExpiry: true,
            })

        } else {

            this.setState({
                isvalidExpiry: false,
            })
        }

        this.setState({
            idExpiry: e.target.value,
            idExpiry1: expDate,
            disabled: false
        }, () => {
            console.log(this.state.idExpiry)
            console.log(this.state.idExpiry1)
            console.log(this.props.profileState.body.idExpiry)
            console.log(this.state.isvalidExpiry)
            if (this.state.idExpiry1 !== this.props.profileState.body.idExpiry) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.isvalidExpiry === true && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
        })

    }
    // handleUpload = () => {
    //     this.setState({
    //         uploadFile: !this.state.uploadFile
    //     })
    // }
    kycResponse = (memberId) => {
        this.getFrankiebyRequestId(memberId)
        this.setState({
            openModal: true
        })
    }
    getFrankiebyRequestId(requestId) {
        let _this = this
        let path = `${s.getFrankieData}${requestId}`
        // let urlpath1 = urlParser(path)
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gfid = getClientId();
        let traceId = getClientId();
        fetch(plink + path, {
            headers: new Headers({
                'Authorization': `Token ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
                'clientId': gfid,
                'clientSecret': getClientSecret(gfid, this.state.memberId),
                 'X-Trace-Id': traceId,
                 'X-KlickEx-Client':buildClientHeader(),
                // 'hmac-value': encryptionUrl(urlpath1),
                // 'clientId': localStorage.getItem('clientId'),
                // 'clientSecret': localStorage.getItem('secretId'),
            })
        }).then(response => {
            if (response.status === 200) {
                response.json().then(json => {


                    _this.setState({
                        openModal: true,
                        selectedKycDetails: json,
                    })
                    toast.success(response.headers.get('message'), {
                        //('Profile Updation Fail!!!', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 60
                    })
                })
            }
            if (response.status === 401) {
                if (this.props.history !== undefined) {
                    this.props.history.push('/sessionOut')
                }
            }
            // else {
            //     toast.error(response.headers.get('message'), {
            //         //('Profile Updation Fail!!!', {
            //         position: "top-right",
            //         autoClose: 3000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         draggablePercent: 60
            //     })
            // }
        })
    }
    closeModal = () => {
        this.setState({
            openModal: false
        })
    }
    handleCheckbox = () => {
        this.setState({
            KycConsent: !this.state.KycConsent
        }, () => {
            if (this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null
                && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
    }
    parseErrors = data => {
        let errors = errorParser(data)
        this.setState({ parsedErrors: errors })
    }
    render() {
        const { basic, homeState, correcthome, correctstate, correctcountry, correctphone, emailState, cityState, correctpasscode, pincodeState, correctEmail, addState, correctCity, stateState, correctadd, selectedCard, cardDetailsId, coreectfirstName, correctMadd, correctMCity, correctMpasscode, correctMstate, } = this.state
        const { profileState, cardState } = this.props
        const { filteredCards, parsedErrors } = this.state

        console.log("Mobile number", this.state.mobileNumber)
        console.log("Email ", this.state.emailId)
        console.log('profileState', this.props.profileState)
        console.log('State', this.state)


        return (
            <div className="col-sm-12" >

                {this.state.selectedKycDetails && <ViewUserModal
                    open={this.state.openModal}
                    onClose={this.closeModal}
                    details={this.state.selectedKycDetails}
                // cardHolderName={this.state.cardholderName}
                />}


                {this.props.profileState && this.props.profileState.body && this.state.loader ? <div style={{ marginTop: "200px" }}><Loader /></div> :
                    <div className="row">
                        <div className="col-sm-12 mt-3" style={{ padding: "0px 30px" }}>
                            <div className="row">

                                <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                    <h4 className='logmainheading mainheading'>Manage Profile</h4>
                                    {/* <p className='subinfo'>Personal Information </p> */}
                                </div>
                            </div>
                        </div>

                        {/* {profileState && profileState.body && profileState.body.profilePicture === null && <div><Loader /></div> } */}
                        {profileState.status === 200 ?
                            <div className="col-md-12 mb-3" style={{ padding: "0px 30px" }}>
                                <div className="mt-5 mb-3 col-md-12 flags text-center  pb-3">
                                    <span className="badge-blue"> To update your details, please access the KlickEx app or online at <a href="https://app.klickex.com/" target="_blank"> app.klickex.com </a></span>
                                </div>
                                {
                                    basic ?
                                        <div className=" col-sm-12">
                                            <div className="row">

                                                <div className="col-md-12 col-sm-12">
                                                    <a className="profile-pic" data-toggle="modal" data-target="#dpupdate">
                                                        {profileState.body.profilePicture !== null ?
                                                            <div className="profile-pic img-circle img-responsive img-bordered-primary profile_image_modifaction" style={{ backgroundImage: `url(${"data:image/jpeg;base64," + profileState.body.profilePicture.mediaInfo || defaultImage})`, borderRadius: "50%" }} >
                                                                <span className="glyphicon glyphicon-camera"></span>
                                                            </div>
                                                            : <div className="profile-pic img-circle img-responsive img-bordered-primary profile_image_modifaction" style={{ backgroundImage: `url(${defaultImage})`, borderRadius: "50%" }} >

                                                                <span className="glyphicon glyphicon-camera"></span>
                                                            </div>}
                                                    </a>
                                                    <div className='mt-2' style={{ cursor: "pointer" }}>
                                                        <a data-toggle="modal" data-target="#dpupdate">

                                                            <i
                                                                className="fa fa-camera"
                                                                aria-hidden="true"
                                                                style={{ marginRight: "3px", }}>
                                                            </i>
                                                            Upload Image
                                                        </a>
                                                    </div>
                                                    <ProfileUpdateModal />
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-sm-12 nopadding">
                                                <div className="row input-group" >

                                                    <div className="col-sm-4" >
                                                        <TextField
                                                            hintText="Type Your First Name"
                                                            floatingLabelText="First Name"
                                                            type="text"
                                                            name="firstName"
                                                            maxLength="30"
                                                            shrink={true}
                                                            autoComplete='off'
                                                            value={profileState.body.firstName || null}
                                                            className="input-width required"
                                                            onChange={this.handleFirstName}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            underlineStyle={styles.underlineStyle1}
                                                            //errorText={coreectfirstName ? null : "Not a valid name"}
                                                            disabled
                                                        />
                                                    </div>

                                                    <div className="col-sm-4" >
                                                        <TextField
                                                            hintText="Type Your Last Name"
                                                            floatingLabelText="Last Name"
                                                            type="text"
                                                            name="lastName"
                                                            maxLength="30"
                                                            shrink={true}
                                                            autoComplete='off'
                                                            value={profileState.body.lastName || null}
                                                            className="input-width required"
                                                            underlineStyle={styles.underlineStyle1}
                                                            onChange={this.handleLastName}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            disabled

                                                        />
                                                    </div>

                                                    <div className="col-sm-4"  >
                                                        <DatePicker hintText="Birthday"
                                                            // container="inline" mode="landscape"
                                                            openToYearSelection={true}
                                                            floatingLabelText="Date Of Birth"
                                                            className="input-width required solidstyle"
                                                            style={{ width: "100%" }}
                                                            type="text"
                                                            name="dateofbirth"
                                                            shrink={true}
                                                            defaultDate={(profileState.body.dobDate) ? new Date(profileState.body.dobDate) : new Date()}
                                                            onChange={this.handleDate}
                                                            formatDate={this.formatDate}
                                                            maxDate={new Date()}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                            disabled

                                                        />
                                                    </div>

                                                </div>

                                            </div>
                                            <div className="col-sm-12">

                                                <div className="row ">

                                                    <div className="header-style mt-5">
                                                        {/* <h4 className='logmainheading mainheading'>Manage Profile</h4> */}
                                                        <p className='subinfo'>Basic Information </p>
                                                    </div>


                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 1"
                                                                    type="text"
                                                                    name="address1"
                                                                    shrink={true}
                                                                    autoComplete='off'
                                                                    maxLength="60"
                                                                    value={this.state.address1 || null}
                                                                    className="input-width required"
                                                                    onChange={this.handleaddress1}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removeadd}
                                                                    disabled
                                                                    // errorText={addState ? correctadd ? null : "Not a valid address" : "This field is required"}
                                                                    errorText={parsedErrors.address ? parsedErrors.address : ""}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 2"
                                                                    type="text"
                                                                    value={this.state.address2 || null}
                                                                    name="address2"
                                                                    maxLength="60"
                                                                    shrink={true}
                                                                    className="input-width"
                                                                    onChange={this.handleaddress2}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    disabled
                                                                    errorText={parsedErrors.address2 ? parsedErrors.address2 : ""}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4 disabled" style={{ cursor: "pointer" }}>
                                                                <label className="form-control-placeholder mb-2 "
                                                                    //onChange={this.handlemcountryempty} 
                                                                    name="country"
                                                                    id="required"
                                                                    style={{ fontSize: "12px", color: "grey", position: "relative", top: "0px", cursor: "pointer" }}>
                                                                    Country
                                                                </label>

                                                                <MultipleSelect
                                                                    className="items-container1"
                                                                    image
                                                                    name="country"
                                                                    items={this.props.countryState}
                                                                    kiey="alpha3Code"
                                                                    value="alpha3Code"
                                                                    default={profileState.body.country || null}
                                                                    description="name"
                                                                    flag="flag"
                                                                    term="name"
                                                                    searchKey="name"
                                                                    disabled={true}
                                                                    //selectValue={this.handlemcountryempty.bind(this)}
                                                                    //errorText={correctcountry ? null : "Not a valid name"}
                                                                    errorText={parsedErrors.country ? parsedErrors.country : ""}

                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="City"
                                                                    value={this.state.city || null}
                                                                    type="text"
                                                                    name="city"
                                                                    shrink={true}
                                                                    maxLength="30"
                                                                    className="input-width required"
                                                                    onChange={this.handlecity}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removecity}
                                                                    underlineStyle={styles.underlineStyle1}
                                                                    disabled
                                                                    //errorText={cityState ? correctCity ? null : "Not a valid city" : "This field is required"}
                                                                    errorText={parsedErrors.city ? parsedErrors.city : ""}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                {(this.state.countryCode !== "AUS") ?
                                                                    <TextField
                                                                        hintText="Start Typing"
                                                                        floatingLabelText="State"
                                                                        type="text"
                                                                        value={this.state.state1 || null}
                                                                        name="state1"
                                                                        shrink={true}
                                                                        maxLength="50"
                                                                        autoComplete='nope'
                                                                        className="input-width required"
                                                                        onChange={this.handlestate1}
                                                                        onFocus={this.removestate}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        underlineStyle={styles.underlineStyle1}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        disabled
                                                                        // errorText={stateState ? correctstate ? null : "Not a valid state" : "This field is required"}
                                                                        errorText={parsedErrors.state ? parsedErrors.state : ""}
                                                                    />
                                                                    :

                                                                    <SelectField
                                                                        floatingLabelText="State"
                                                                        onChange={this.handleStatedropdown}
                                                                        className="input-width required simsfont disabled"
                                                                        name="state1"
                                                                        shrink={true}
                                                                        value={this.state.state1}
                                                                        disabled
                                                                    >
                                                                        <MenuItem className="menuitem" value="ACT" primaryText="ACT" />
                                                                        <MenuItem className="menuitem" value="NSW" primaryText="NSW" />
                                                                        <MenuItem className="menuitem" value="NT" primaryText="NT" />
                                                                        <MenuItem className="menuitem" value="QLD" primaryText="QLD" />
                                                                        <MenuItem className="menuitem" value="SA" primaryText="SA" />
                                                                        <MenuItem className="menuitem" value="TAS" primaryText="TAS" />
                                                                        <MenuItem className="menuitem" value="VIC" primaryText="VIC" />
                                                                    </SelectField>

                                                                }
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Post Code"
                                                                    type="text"
                                                                    name="pincode"
                                                                    maxLength="4"
                                                                    shrink={true}
                                                                    onChange={this.handlepincode.bind(this)}
                                                                    // onInput={(e) => {
                                                                    //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                                                    // }}     
                                                                    autoComplete='off'
                                                                    className="input-width required"
                                                                    value={this.state.pincode || null}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removepasscode}
                                                                    disabled
                                                                    // errorText={pincodeState ? correctpasscode ? null : "Not a valid Postcode" : "This field is required"}
                                                                    errorText={parsedErrors.pinCode ? parsedErrors.pinCode : ""}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 ">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-4 nopadding " >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Email"
                                                                    type="text"
                                                                    value={this.state.emailId || null}
                                                                    name="emailId"
                                                                    maxLength="50"
                                                                    shrink={true}
                                                                    className="input-width required"
                                                                    onChange={this.handelemail}
                                                                    autoComplete='none'
                                                                    onFocus={this.removeemail}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    disabled
                                                                    // errorText={emailState ? correctEmail ? null : "Not a valid email" : "This field is required"}
                                                                    errorText={parsedErrors.emailId ? parsedErrors.emailId : ""}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Mobile Number"
                                                                    type="text"
                                                                    value={this.state.mobileNumber || null}
                                                                    name="mobileNumber"
                                                                    shrink={true}
                                                                    maxLength="20"
                                                                    autoComplete='off'
                                                                    // onInput={(e) => {
                                                                    //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                                                    // }}
                                                                    className="input-width required"
                                                                    onChange={this.handelmobileNumber.bind(this)}
                                                                    // onBlur={this.handleMobile}
                                                                    // onFocus={this.removephone}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    disabled
                                                                    // errorText={correctphone ? null : "Not a valid phone number"}
                                                                    errorText={parsedErrors.mobileNumber ? parsedErrors.mobileNumber : ""}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {(this.state.documentFront !== "" && this.state.documentFront !== null) &&
                                                        <div className="col-md-8 col-sm-12">
                                                            <div className="row">
                                                                <div className="simsfont doc-header col-sm-12">
                                                                    <p>Document Preview</p>
                                                                </div>
                                                                <div className=" col-sm-12">
                                                                    {(this.state.fileType !== "application/pdf") ?
                                                                        (<img src={"data:image/" + this.state.fileType + ";base64," + this.state.documentFront} style={{ width: "50%", }} />)
                                                                        :
                                                                        <div className="doc-preview col-sm-12">
                                                                            <div className="doc-body-pdf">
                                                                                <ConsumerPdfViewer
                                                                                    file={this.state.documentFront}
                                                                                    name={this.state.fileName}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }


                                                    <div className="col-md-12 col-sm-12">
                                                        <div className="row" >

                                                            {/* <div className="col-md-5 col-sm-5">
                                                                <div className="row input-group mt-2" >
                                                                    <RaisedButton
                                                                        label="Update"
                                                                        onClick={this.handleSubmit}
                                                                        backgroundColor="#FFCE39"
                                                                        labelColor="#115876"
                                                                        type="submit"
                                                                        className="btn-std"
                                                                        buttonStyle={{ borderRadius: 6 }}
                                                                    />
                                                                </div>
                                                            </div> */}
                                                            {this.state.loader === true &&
                                                                <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                                    <LoaderSmall />
                                                                </div>}
                                                        </div>
                                                    </div>
                                                    <hr />

                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                        </div>}
                            </div>
                            : <div> </div>}
                    </div>}
            </div>
        );
    }
}
PersonalInfo.defaultProps = {
    profileState: {
        status: 600
    },
    cardState: {
        status: 600
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);


// WEBPACK FOOTER //
// ./src/components/myprofile/personalinfo.jsx